<template>
  <div class="workspace">
    <div class="section-heading">
      <h2>Catering Menu</h2>
    </div>
    <tabs-default :restaurantId="restaurantId"></tabs-default>
  </div>
</template>

<script>
import TabsDefault from './tabs/TabsDefault.vue'
import vSelect from 'vue-select'

export default{
  components: {
    TabsDefault,
    'v-select': vSelect
  },
  data () {
    return {
      restaurantId: -1,
      tab_data: {}
    }
  },
  watch: {
  },
  methods: {
  },
  mounted () {
    this.restaurantId = -1
  },
  computed: {
  }
}
</script>
<style>
  .vs--single.vs--open .vs__selected{
    position: initial;
  }
</style>
